import { createFarmApi } from 'core/api/apiFactory'
import { useParams } from 'react-router-dom'

const useFarmApi = () => {
  const { farmId } = useParams<{ farmId: string }>()
  if (!farmId) throw new Error('Farm ID is missing')

  return createFarmApi(farmId)
}

export default useFarmApi
